import pramodaya from "../assets/business/pramodaya.png";
import smg from "../assets/business/SMG Logo.png";
import tigi from "../assets/business/logo.jpg";
import alteco from "../assets/business/alteco.png";
import advith from "../assets/business/Advith.jpeg";
import veritas from "../assets/business/veritas.jpeg";

function Testimonials() {
  const clients = [
    {
      logo: pramodaya,
      title: "Pramodaya",
      place: "Mumbai",
    },
    {
      logo: smg,
      title: "SMG Schools",
      place: "Thane",
    },
    {
      logo: tigi,
      title: "TIGI Industries",
      place: "Gujarat",
    },
    {
      logo: alteco,
      title: "Alteco Minerals",
      place: "Mumbai",
    },
    {
      logo: advith,
      title: "Advith",
      place: "Australia",
    },
    {
      logo: veritas,
      title: "Veritas Institute",
      place: "Australia",
    },
  ];

  return (
    <section className="trust-section">
      <div className="container">
        <div className="section-title">
          <span className="section-subtitle">TRUSTED BY BUSINESSES</span>
          <h2>Businesses We Have Worked With</h2>
        </div>

        <div className="client-logos">
          {clients.map((client, index) => (
            <div key={index} className="client-card">
              <div className="client-logo">
                <img src={client.logo} alt={client.title} />
              </div>

              <div className="client-info">
                <div className="client-title">{client.title}</div>
                <div className="client-place">{client.place}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="trust-message">
          <h3>Building Digital Assets That Drive Growth</h3>
          <p>
            From educational institutions to manufacturing companies, Adyah
            helps organizations establish stronger digital presence and
            operational efficiency.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
